import InputWrapper from "../../../../../../../components/input/wrapper/InputWrapper";
import { useLanguageContext } from "../../../../../../../context/LanguageContext";
import EVAApiHelper from "../../../../../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../../../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../../../../../styles/LayoutStyles";

function PositionFormView({
  selectedLabelItem,
  selectedLabelItemIndex,
  onXPositionChange,
  onYPositionChange,
  submitError,
}) {
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn>
      <StyledFlexRow>
        <StyledFlexItem>
          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.label_items.*.position.x"
            )}
            required
            error={EVAApiHelper.getResponseError(
              `label_items.${selectedLabelItemIndex}.position.x`,
              submitError
            )}
          >
            <StyledInput
              type="number"
              value={selectedLabelItem.position.x}
              onChange={onXPositionChange}
            />
          </InputWrapper>
        </StyledFlexItem>

        <StyledFlexItem>
          <InputWrapper
            label={translate(
              "eva.main.validation.attributes.label_items.*.position.y"
            )}
            required
            error={EVAApiHelper.getResponseError(
              `label_items.${selectedLabelItemIndex}.position.y`,
              submitError
            )}
          >
            <StyledInput
              type="number"
              value={selectedLabelItem.position.y}
              onChange={onYPositionChange}
            />
          </InputWrapper>
        </StyledFlexItem>
      </StyledFlexRow>
    </StyledFlexColumn>
  );
}

export default PositionFormView;
